import React from 'react';

const ErrorState = ({ message }) => {
  return (
    <div className="flex flex-col items-center justify-center py-20">
      <div className="bg-red-900/20 border border-red-700/50 rounded-lg p-6 max-w-md">
        <h3 className="text-red-400 font-semibold text-lg mb-2">Error al cargar perfiles</h3>
        <p className="text-slate-300 text-sm">{message}</p>
        <button 
          onClick={() => window.location.reload()}
          className="mt-4 px-4 py-2 bg-red-600 hover:bg-red-500 text-white rounded-lg transition-colors"
        >
          Reintentar
        </button>
      </div>
    </div>
  );
};

export default ErrorState;
